/**
 * Composable para formatação de NCM e CEST
 */
export function useNcmCest() {
  /**
   * Formatar NCM com máscara 0000.00.00
   * @param {string|number} value - Valor do NCM
   * @returns {string} NCM formatado
   */
  const formatNCM = (value) => {
    if (!value) return '';

    // Remove formatação e limita a 8 dígitos
    const digits = value
      .toString()
      .replace(/\D/g, '')
      .substring(0, 8);

    // Aplica a máscara 0000.00.00
    return digits.replace(
      /(\d{4})(\d{2})?(\d{2})?/,
      (_, p1, p2, p3) => p1 + (p2 ? '.' + p2 : '') + (p3 ? '.' + p3 : '')
    );
  };

  /**
   * Remover formatação do NCM (apenas dígitos)
   * @param {string} value - NCM formatado
   * @returns {string} NCM sem formatação
   */
  const unformatNCM = (value) => {
    return value ? value.replace(/\D/g, '') : '';
  };

  /**
   * Formatar CEST com máscara 00.000.00
   * @param {string|number} value - Valor do CEST
   * @returns {string} CEST formatado
   */
  const formatCEST = (value) => {
    if (!value) return '';

    // Remove formatação e limita a 7 dígitos
    const digits = value
      .toString()
      .replace(/\D/g, '')
      .substring(0, 7);

    // Aplica a máscara 00.000.00
    return digits.replace(
      /(\d{2})(\d{3})?(\d{2})?/,
      (_, p1, p2, p3) => p1 + (p2 ? '.' + p2 : '') + (p3 ? '.' + p3 : '')
    );
  };

  /**
   * Remover formatação do CEST (apenas dígitos)
   * @param {string} value - CEST formatado
   * @returns {string} CEST sem formatação
   */
  const unformatCEST = (value) => {
    return value ? value.replace(/\D/g, '') : '';
  };

  return {
    formatNCM,
    unformatNCM,
    formatCEST,
    unformatCEST,
  };
}
